import classnames from "classnames";
import React from "react";

import { PHONE_PATTERN, EMAIL_PATTERN } from "../../const/Patterns";

import {
  gaEvent,
  virtualPageView,
} from "../../shared/helpers/gtm_tracking";

class CustomerDetailsForm extends React.Component {
  constructor() {
    super();

    this.buttonLabel = "Book this deal";

    this.state = {
      first_name: { value: "", valid: true },
      last_name: { value: "", valid: true },
      email: { value: "", valid: true },
      phone: { value: "", valid: true },
      address_line1: { value: "", valid: true },
      address_city: { value: "", valid: true },
      address_postcode: { value: "", valid: true },
      address_country: { value: "", valid: true },
      opt_in: { value: true, valid: true },
    };
  }

  updateFieldValue = e => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const fieldName = e.target.name;

    this.setState({ [fieldName]: { value: value, valid: true } });
  };

  hasValue = input => !!input.value.length;

  isInputValid = (input, pattern) => (
    this.hasValue(input) && pattern.test(input.value)
  );

  _trackCTAClick = () => {
    gaEvent("Last Minute Page", "Deal", this.buttonLabel);
    virtualPageView("BOOKING_STRIPE_CHECKOUT");
  };

  bookOffer = () => {
    const { selectedPax, selectedTeeTimes } = this.props;
    const teeTimeIds = Object.values(selectedTeeTimes);
    const { state } = this;
    const params = Object.keys(state).map(fieldName => {
      const obj = {};
      obj[fieldName] = state[fieldName].value;

      return obj;
    });
    const customerParams = Object.assign({}, ...params);

    this._trackCTAClick();
    this.props.bookOffer(selectedPax, teeTimeIds, customerParams);
  };

  allFieldsValid = () => {
    const { state } = this;

    return Object
      .keys(state)
      .map(fieldName => state[fieldName].valid)
      .every(Boolean);
  };

  validateAndBookOffer = e => {
    e.preventDefault();

    this.setState(prevState => {
      Object
        .keys(prevState)
        .forEach(fieldName => {
          prevState[fieldName].valid = this.hasValue(prevState[fieldName]);
        });

      prevState.email.valid = this.isInputValid(prevState.email, EMAIL_PATTERN);
      prevState.phone.valid = this.isInputValid(prevState.phone, PHONE_PATTERN);
      prevState.opt_in.valid = true;

      return prevState;
    }, () => {
      if (this.allFieldsValid()) {
        this.bookOffer();
      }
    });
  };

  render() {
    const errorMessage = "This field is required";

    return (
      <form className="venue__offer__form" id="customer-details-form">
        <div className="venue__offer__content">
          <div className="venue__offer__subtitle"><strong>Billing Details</strong></div>
          <div className="layout layout--small">
            <div className="form-control__placeholder-label layout__item u-1/2-tab u-1/2-desk">
              <label>First name</label>
              <input
                className={classnames(
                  "form-control",
                  "form-control--custom",
                  "js-floating-placeholder",
                  this.state.first_name.valid || "is-invalid"
                )}
                name="first_name"
                placeholder="First name*"
                onChange={this.updateFieldValue}
                required
              />
              {this.state.first_name.valid ||
                <span className="is-invalid__message">{errorMessage}</span>}
            </div>
            <div className="form-control__placeholder-label layout__item u-1/2-tab u-1/2-desk">
              <label>Last name</label>
              <input
                className={classnames(
                  "form-control",
                  "form-control--custom",
                  "js-floating-placeholder",
                  this.state.last_name.valid || "is-invalid"
                )}
                name="last_name"
                placeholder="Last name*"
                onChange={this.updateFieldValue}
                required
              />
              {this.state.last_name.valid ||
                <span className="is-invalid__message">{errorMessage}</span>}
            </div>
            <div className="form-control__placeholder-label layout__item u-1/2-tab u-1/2-desk">
              <label>Email</label>
              <input
                type="email"
                className={classnames(
                  "form-control",
                  "form-control--custom",
                  "js-floating-placeholder",
                  this.state.email.valid || "is-invalid"
                )}
                name="email"
                placeholder="Email address*"
                onChange={this.updateFieldValue}
                required
              />
              {this.state.email.valid ||
                <span className="is-invalid__message">This must be a valid email address</span>}
            </div>
            <div className="form-control__placeholder-label layout__item u-1/2-tab u-1/2-desk">
              <label>Phone</label>
              <input
                className={classnames(
                  "form-control",
                  "form-control--custom",
                  "js-floating-placeholder",
                  this.state.phone.valid || "is-invalid"
                )}
                name="phone"
                placeholder="Phone number*"
                onChange={this.updateFieldValue}
                required
              />
              {this.state.phone.valid ||
                <span className="is-invalid__message">{errorMessage}</span>}
            </div>
            <div className="form-control__placeholder-label layout__item u-1/2-tab u-1/2-desk">
              <label>Address</label>
              <input
                className={classnames(
                  "form-control",
                  "form-control--custom",
                  "js-floating-placeholder",
                  this.state.address_line1.valid || "is-invalid"
                )}
                name="address_line1"
                placeholder="Address*"
                onChange={this.updateFieldValue}
                required
              />
              {this.state.address_line1.valid ||
                <span className="is-invalid__message">{errorMessage}</span>}
            </div>
            <div className="form-control__placeholder-label layout__item u-1/2-tab u-1/2-desk">
              <label>City</label>
              <input
                className={classnames(
                  "form-control",
                  "form-control--custom",
                  "js-floating-placeholder",
                  this.state.address_city.valid || "is-invalid"
                )}
                name="address_city"
                placeholder="City*"
                onChange={this.updateFieldValue}
                required
              />
              {this.state.address_city.valid ||
                <span className="is-invalid__message">{errorMessage}</span>}
            </div>
            <div className="form-control__placeholder-label layout__item u-1/2-tab u-1/2-desk">
              <label>Postcode</label>
              <input
                className={classnames(
                  "form-control",
                  "form-control--custom",
                  "js-floating-placeholder",
                  this.state.address_postcode.valid || "is-invalid"
                )}
                name="address_postcode"
                placeholder="Postcode*"
                onChange={this.updateFieldValue}
                required
              />
              {this.state.address_postcode.valid ||
                <span className="is-invalid__message">{errorMessage}</span>}
            </div>
            <div className="form-control__placeholder-label layout__item u-1/2-tab u-1/2-desk">
              <label>Country</label>
              <input
                className={classnames(
                  "form-control",
                  "form-control--custom",
                  "js-floating-placeholder",
                  this.state.address_country.valid || "is-invalid"
                )}
                name="address_country"
                placeholder="Country*"
                onChange={this.updateFieldValue}
                required
              />
              {this.state.address_country.valid ||
                <span className="is-invalid__message">{errorMessage}</span>}
            </div>
            <div className="layout__item checkbox">
              <label>
                <input
                  type="checkbox"
                  name="opt_in"
                  defaultChecked="true"
                  onChange={this.updateFieldValue}
                />
                {this.props.consentStatement}
                <a href="/privacy" rel="noopener" target="_blank" className="gtm-track-click" data-gtm-category="Last Minute Page" data-gtm-action="Deal" data-gtm-label="Privacy Policy"> Learn more about how Your Golf Travel collects and uses personal data.</a>
              </label>
            </div>
            <div className="layout__item u-1/2-tab u-1/2-desk">
              <span className="is-invalid__message">*Required fields</span>
            </div>
          </div>
        </div>
        <div className="venue__offer__ctas">
          <button
            className="venue__offer__cta button button--alt--solid gtm-track-click"
            onClick={this.validateAndBookOffer}
          >
            {this.buttonLabel} <span className="button--subtext">{this.props.bookButtonSubText}</span>
          </button>
        </div>
      </form>
    );
  }
}

export default CustomerDetailsForm;



// WEBPACK FOOTER //
// ./components/last_minute_deals/CustomerDetailsForm.js